import * as React from 'react';
import Icon from '../Icon';


var ContextMenuIcon = function (_a) {
    var onClick = _a.onClick;
    return (React.createElement(Icon, { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", className: 'ContextMenuIcon', onClick: onClick },
        React.createElement("circle", { cx: "9.61539", cy: "4.61538", r: "1.61538", fill: "#111111" }),
        React.createElement("circle", { cx: "9.61539", cy: "10", r: "1.61538", fill: "#111111" }),
        React.createElement("circle", { cx: "9.61539", cy: "15.3846", r: "1.61538", fill: "#111111" })));
};
export default React.memo(ContextMenuIcon);
